import { CountryCode, E164Number } from 'libphonenumber-js/types';
import { memo } from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import 'react-phone-number-input/style.css';
import './SelectPhoneNumber.tailwind.css';

interface SelectPhoneNumberProps {
  id?: string;
  isRequired?: boolean;
  label?: string;
  name?: string;
  value?: E164Number;
  onChange?: (phoneNumber?: string, phoneNumberIsValid?: boolean) => void;
  defaultCountry?: CountryCode;
}
//TO DO:errors and validation with withController HOC react-hook-form
const SelectPhoneNumber = ({
  value,
  onChange,
  defaultCountry = 'AR',
  label,
  name,
  id,
  isRequired = false,
}: SelectPhoneNumberProps) => {
  const handleOnChange = (value: E164Number) => {
    onChange?.(value, isValidPhoneNumber(value));
  };

  return (
    <div {...(id && { id })} className="flex w-full flex-col">
      {label && (
        <label className="label" htmlFor={name}>
          {label} {isRequired && <span className="text-red-500"> * </span>}
        </label>
      )}
      <PhoneInput
        {...(id && { id: `${id}-input` })}
        {...(name && { name })}
        international
        className="select-phone-number"
        defaultCountry={defaultCountry}
        value={value}
        onChange={handleOnChange}
      />
    </div>
  );
};

export default memo(SelectPhoneNumber);
